var _path, _g, _g2, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSelectChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7861 58.5101C54.7861 50.6539 61.1548 44.2852 69.0111 44.2852H84.4214C92.2776 44.2852 98.6463 50.6539 98.6463 58.5101V85.7745C98.6463 93.6307 92.2776 99.9994 84.4214 99.9994H69.011C61.1548 99.9994 54.7861 93.6307 54.7861 85.7745V58.5101Z",
    fill: "#3FB083"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_biii_2877_47492)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7618 62.3164H88.7007C89.9063 62.3164 90.9061 63.3178 90.9061 64.5253C90.9061 65.7328 89.9063 66.7047 88.7007 66.7047H78.7618C77.5561 66.7047 76.5564 65.7328 76.5564 64.5253C76.5564 63.3178 77.5561 62.3164 78.7618 62.3164ZM88.7009 81.4298H72.7044C71.4988 81.4298 70.499 80.4285 70.499 79.221C70.499 78.0134 71.4988 77.0415 72.7044 77.0415H88.7009C89.9065 77.0415 90.9062 78.0134 90.9062 79.221C90.9062 80.4285 89.9065 81.4298 88.7009 81.4298Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_biiii_2877_47492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2139 17.1429C16.2139 7.67511 23.889 0 33.3567 0H61.2349C63.5082 0 65.6884 0.903059 67.2958 2.51051L76.2139 11.4286L85.1319 20.3466C86.7394 21.9541 87.6424 24.1343 87.6424 26.4075V72.8571C87.6424 82.3249 79.9673 90 70.4996 90H33.3567C23.889 90 16.2139 82.3249 16.2139 72.8571V17.1429Z",
    fill: "#F4F4F4",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7139 17.1429C16.7139 7.95126 24.1651 0.5 33.3567 0.5H61.2349C63.3756 0.5 65.4286 1.35038 66.9423 2.86407L75.8603 11.7821L84.7784 20.7002C86.2921 22.2139 87.1424 24.2669 87.1424 26.4075V72.8571C87.1424 82.0487 79.6912 89.5 70.4996 89.5H33.3567C24.1651 89.5 16.7139 82.0487 16.7139 72.8571V17.1429Z",
    stroke: "#F0F3F2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0556 47H27.8697C26.0276 47 24.5 48.53 24.5 50.375C24.5 52.22 26.0276 53.705 27.8697 53.705H43.0556C44.8977 53.705 46.4253 52.22 46.4253 50.375C46.4253 48.53 44.8977 47 43.0556 47ZM27.8697 76.2037H52.311C54.153 76.2037 55.6806 74.6737 55.6806 72.8287C55.6806 70.9837 54.153 69.4987 52.311 69.4987H27.8697C26.0276 69.4987 24.5 70.9837 24.5 72.8287C24.5 74.6737 26.0276 76.2037 27.8697 76.2037Z",
    fill: "#F0F3F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3239 33.105C67.4554 33.1365 71.809 33.15 75.5022 33.1365C77.3937 33.132 78.3552 30.8685 77.0432 29.505C72.2988 24.564 63.8117 15.7215 58.9549 10.6635C57.6115 9.26402 55.2617 10.227 55.2617 12.1665V24.0285C55.2617 29.0055 59.3547 33.105 64.3239 33.105Z",
    fill: "#F0F3F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9554 23.928C28.5718 23.928 29.0714 23.4284 29.0714 22.8119V10.9816C29.0714 8.51991 27.0688 6.5173 24.6071 6.5173H23.1562V5.40123C23.1562 4.78477 22.6566 4.28516 22.0402 4.28516C21.4237 4.28516 20.9241 4.78477 20.9241 5.40123V6.5173H15.846V5.40123C15.846 4.78477 15.3464 4.28516 14.7299 4.28516C14.1135 4.28516 13.6138 4.78477 13.6138 5.40123V6.5173H8.59152V5.40123C8.59152 4.78477 8.0919 4.28516 7.47545 4.28516C6.85899 4.28516 6.35938 4.78477 6.35938 5.40123V6.5173H4.96429C2.50261 6.5173 0.5 8.51991 0.5 10.9816V28.3923C0.5 30.854 2.50261 32.8566 4.96429 32.8566H24.6071C27.0688 32.8566 29.0714 30.854 29.0714 28.3923C29.0714 27.7758 28.5718 27.2762 27.9554 27.2762C27.3389 27.2762 26.8393 27.7758 26.8393 28.3923C26.8393 29.623 25.8379 30.6244 24.6071 30.6244H4.96429C3.73356 30.6244 2.73214 29.623 2.73214 28.3923V15.4459H26.8393V22.8119C26.8393 23.4284 27.3389 23.928 27.9554 23.928ZM2.73214 13.2137V10.9816C2.73214 9.75085 3.73356 8.74944 4.96429 8.74944H6.35938V9.86551C6.35938 10.482 6.85899 10.9816 7.47545 10.9816C8.0919 10.9816 8.59152 10.482 8.59152 9.86551V8.74944H13.6138V9.86551C13.6138 10.482 14.1135 10.9816 14.7299 10.9816C15.3464 10.9816 15.846 10.482 15.846 9.86551V8.74944H20.9241V9.86551C20.9241 10.482 21.4237 10.9816 22.0402 10.9816C22.6566 10.9816 23.1562 10.482 23.1562 9.86551V8.74944H24.6071C25.8379 8.74944 26.8393 9.75085 26.8393 10.9816V13.2137H2.73214ZM20.3103 23.091C20.3103 23.7074 19.8107 24.207 19.1942 24.207C18.5777 24.207 18.0781 23.7074 18.0781 23.091C18.0781 22.4745 18.5777 21.9749 19.1942 21.9749C19.8107 21.9749 20.3103 22.4745 20.3103 23.091ZM15.9018 23.091C15.9018 23.7074 15.4022 24.207 14.7857 24.207C14.1693 24.207 13.6696 23.7074 13.6696 23.091C13.6696 22.4745 14.1693 21.9749 14.7857 21.9749C15.4022 21.9749 15.9018 22.4745 15.9018 23.091ZM20.3103 18.6267C20.3103 19.2431 19.8107 19.7427 19.1942 19.7427C18.5777 19.7427 18.0781 19.2431 18.0781 18.6267C18.0781 18.0102 18.5777 17.5106 19.1942 17.5106C19.8107 17.5106 20.3103 18.0102 20.3103 18.6267ZM6.97321 18.6267C6.97321 19.2431 6.4736 19.7427 5.85714 19.7427C5.24069 19.7427 4.74107 19.2431 4.74107 18.6267C4.74107 18.0102 5.24069 17.5106 5.85714 17.5106C6.4736 17.5106 6.97321 18.0102 6.97321 18.6267ZM24.7188 18.6267C24.7188 19.2431 24.2191 19.7427 23.6027 19.7427C22.9862 19.7427 22.4866 19.2431 22.4866 18.6267C22.4866 18.0102 22.9862 17.5106 23.6027 17.5106C24.2191 17.5106 24.7188 18.0102 24.7188 18.6267ZM24.7188 23.091C24.7188 23.7074 24.2191 24.207 23.6027 24.207C22.9862 24.207 22.4866 23.7074 22.4866 23.091C22.4866 22.4745 22.9862 21.9749 23.6027 21.9749C24.2191 21.9749 24.7188 22.4745 24.7188 23.091ZM20.3103 27.5552C20.3103 28.1717 19.8107 28.6713 19.1942 28.6713C18.5777 28.6713 18.0781 28.1717 18.0781 27.5552C18.0781 26.9388 18.5777 26.4392 19.1942 26.4392C19.8107 26.4392 20.3103 26.9388 20.3103 27.5552ZM6.97321 23.091C6.97321 23.7074 6.4736 24.207 5.85714 24.207C5.24069 24.207 4.74107 23.7074 4.74107 23.091C4.74107 22.4745 5.24069 21.9749 5.85714 21.9749C6.4736 21.9749 6.97321 22.4745 6.97321 23.091ZM11.4375 18.6267C11.4375 19.2431 10.9379 19.7427 10.3214 19.7427C9.70497 19.7427 9.20536 19.2431 9.20536 18.6267C9.20536 18.0102 9.70497 17.5106 10.3214 17.5106C10.9379 17.5106 11.4375 18.0102 11.4375 18.6267ZM6.97321 27.5552C6.97321 28.1717 6.4736 28.6713 5.85714 28.6713C5.24069 28.6713 4.74107 28.1717 4.74107 27.5552C4.74107 26.9388 5.24069 26.4392 5.85714 26.4392C6.4736 26.4392 6.97321 26.9388 6.97321 27.5552ZM11.4375 23.091C11.4375 23.7074 10.9379 24.207 10.3214 24.207C9.70497 24.207 9.20536 23.7074 9.20536 23.091C9.20536 22.4745 9.70497 21.9749 10.3214 21.9749C10.9379 21.9749 11.4375 22.4745 11.4375 23.091ZM11.4375 27.5552C11.4375 28.1717 10.9379 28.6713 10.3214 28.6713C9.70497 28.6713 9.20536 28.1717 9.20536 27.5552C9.20536 26.9388 9.70497 26.4392 10.3214 26.4392C10.9379 26.4392 11.4375 26.9388 11.4375 27.5552ZM15.9018 18.6267C15.9018 19.2431 15.4022 19.7427 14.7857 19.7427C14.1693 19.7427 13.6696 19.2431 13.6696 18.6267C13.6696 18.0102 14.1693 17.5106 14.7857 17.5106C15.4022 17.5106 15.9018 18.0102 15.9018 18.6267ZM15.9018 27.5552C15.9018 28.1717 15.4022 28.6713 14.7857 28.6713C14.1693 28.6713 13.6696 28.1717 13.6696 27.5552C13.6696 26.9388 14.1693 26.4392 14.7857 26.4392C15.4022 26.4392 15.9018 26.9388 15.9018 27.5552Z",
    fill: "#92CAB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_biii_2877_47492",
    x: 65.809,
    y: 57.6264,
    width: 29.7872,
    height: 28.4932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.34499
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2877_47492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2877_47492",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.1725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34499
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2877_47492"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.1725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34499
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2877_47492",
    result: "effect3_innerShadow_2877_47492"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.1725
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.586248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.95 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2877_47492",
    result: "effect4_innerShadow_2877_47492"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_biiii_2877_47492",
    x: 10.4996,
    y: -5.71429,
    width: 82.8573,
    height: 101.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2877_47492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2877_47492",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2877_47492"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2877_47492",
    result: "effect3_innerShadow_2877_47492"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.4286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_2877_47492",
    result: "effect4_innerShadow_2877_47492"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.42857,
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_2877_47492",
    result: "effect5_innerShadow_2877_47492"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectChat);
export default __webpack_public_path__ + "static/media/select-chat.e773e22415fe580da837ac2d1479a4e9.svg";
export { ForwardRef as ReactComponent };